<div class="header">
  <spb-logo title="Spärra BankID"></spb-logo>
  <div class="right">
    <spb-toggle-button/>
    @if (service.currentUser()) {
      <span>{{ service.currentUser()?.name }}</span>
      <button [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  </div>
</div>

<!-- Add other fancy navigations here -->
<mat-menu #menu="matMenu">
  <button [routerLink]="['/main']" mat-menu-item>Spärra BankID</button>
  @if (service.roles().includes(ADMIN_ROLE_NAME)) {
    <button [routerLink]="['/admin']" mat-menu-item>Admin tjänster</button>
  }
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>
